var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
import React from "react";
import { FormRadio, FormRadioGroup } from "../elements/Radio";
function SubscribeSection(_ref) {
  var formatMessage = _ref.intl.formatMessage;
  return /* @__PURE__ */ React.createElement(FormRadioGroup, null, /* @__PURE__ */ React.createElement(FormRadio, {
    value: true
  }, formatMessage({
    id: "forms.common.confirmSubscribeYes"
  })), /* @__PURE__ */ React.createElement(FormRadio, {
    value: false
  }, formatMessage({
    id: "forms.common.confirmSubscribeNo"
  })));
}
__name(SubscribeSection, "SubscribeSection");
export {
  SubscribeSection
};
